
import { Base } from "../core/base.model";
import { ConsultaList } from "../core/ConsultaList.model";
import { UsuarioFise } from "../security/userbean.model";



export class Servidor extends Base{
    
    id_Servidor: number;
    ip: string;
    descripcion: string;
    tipoServidor: string;
    so: string;
    ubicacion: string;
    userObject:UsuarioFise []= [];
}
